// Exports
export default {
	"button": "button_bATbt"
};
